import { Component, HostListener, OnInit, ViewEncapsulation } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { ColumnDefinition } from 'src/app/dto/columnDefinition';
import { DealerEmployee } from 'src/app/models/dealer-employee.model';
import { Report } from 'src/app/models/report.model';
import { User } from 'src/app/models/user.model';
import { ClickStreamService } from 'src/app/services/click-stream.service';
import { DealersService } from 'src/app/services/dealers.service';
import { ReportsService } from 'src/app/services/reports.service';
import { UserService } from 'src/app/services/user.service';
import { ViewEntityType, ViewsService } from 'src/app/services/views.service';
import { plaintext } from "../../../assets/plaintext";
import { AdminsDialogComponent } from '../admins-dialog/admins-dialog.component';
import { ViewReportsAsDialogComponent } from '../view-reports-as-dialog/view-reports-as-dialog.component';

@Component({
  selector: 'app-reports',
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.scss']
})
export class ReportsComponent implements OnInit {

  userReports: Report[] = [];
  pscAdmins: DealerEmployee[] = [];

  isLoading = false;

  user: User;
  userInitials: string;

  isMobile = false;

  bac: string;
  dealerName: string;
  userId: string;
  userRole: string;
  userName: string;
  viewingDashboardAsPSC: boolean;
  viewingDashboardAsEmployee: boolean;
  plaintext = plaintext;

  pscAdminColumns: ColumnDefinition[] = [
    { columnDef: 'gmvssmadminroledn', header: 'Admin Type', cell: (w: any) => `${w.gmvssmadminroledn}` },
    { columnDef: 'name', header: 'Name', cell: (w: any) => `${w.name}` },
    { columnDef: 'email', header: 'Contact', cell: (w: any) => `${w.mail}` }
  ];

  constructor(private reportService: ReportsService, private router: Router, private userService: UserService, private viewService: ViewsService, public dialog: MatDialog,
    private dealersService : DealersService, private route: ActivatedRoute, private clickstream: ClickStreamService) { 
      this.route.params.subscribe(val => {
        this.fetchData();
      })
    }

  ngOnInit() {
    if (this.userService.user.businessFunction !== 'dealeradmin' && this.userService.user.businessFunction !== 'DEALER') this.router.navigate(['/']);
    this.user = this.userService.user;
    this.userInitials = this.user.name.split(" ").map((n)=>n[0]).join("");
    this.isMobile = window.innerWidth < 768;
  }

  fetchData() {
    this.isLoading = true;
    if (window.location.href.includes('viewas')) {
      
      this.userId = this.route.snapshot.paramMap.get('userId');
      this.bac = this.route.snapshot.paramMap.get('bac');
      if (!this.userId) {
        this.viewingDashboardAsPSC = true;
      } else {
        this.viewingDashboardAsEmployee = true;
      }
      this.route.queryParams.subscribe(params => {
        this.userName = params['user'];
        this.dealerName = params['dealer'];
        this.userRole = params['role'];
      });
      if (this.userRole == 'PSC' && this.userService.user.isPSC) {
        this.reportService.getReports().subscribe(data => {
          this.userReports = data;
          for (let r of this.userReports) {
            r.tooltip = `ASMS: ${r.asms ? r.asms : ''} \n` +
              `Report Owner: ${r.reportOwner ? r.reportOwner.name : ''} \n` +
              `Business Owner: ${r.businessOwner ? r.businessOwner.name : ''} \r\n` +
              `Operations Owner: ${r.operationsOwner ? r.operationsOwner.name : ''} \r\n` +
              `Innovation Owner: ${r.innovationOwner ? r.innovationOwner.name : ''} \r\n`
          }
          this.isLoading = false;
        })
      } else {
        this.reportService.getReportsOf(this.bac, this.userRole != 'USER' ? null : this.userId).subscribe(data => {
          this.userReports = data;
          for (let r of this.userReports) {
            r.tooltip = `ASMS: ${r.asms ? r.asms : ''} \n` +
              `Report Owner: ${r.reportOwner ? r.reportOwner.name : ''} \n` +
              `Business Owner: ${r.businessOwner ? r.businessOwner.name : ''} \r\n` +
              `Operations Owner: ${r.operationsOwner ? r.operationsOwner.name : ''} \r\n` +
              `Innovation Owner: ${r.innovationOwner ? r.innovationOwner.name : ''} \r\n`
          }
          if (this.userReports && this.userReports.length == 0) {
            this.getPSCAdmins();
          } else {
            this.isLoading = false;            
          }
        })
      }
    } else {
      this.reportService.getReports().subscribe(data => {
        this.userReports = data;
        for (let r of this.userReports) {
          r.tooltip = `ASMS: ${r.asms ? r.asms : ''} \n` +
            `Report Owner: ${r.reportOwner ? r.reportOwner.name : ''} \n` +
            `Business Owner: ${r.businessOwner ? r.businessOwner.name : ''} \r\n` +
            `Operations Owner: ${r.operationsOwner ? r.operationsOwner.name : ''} \r\n` +
            `Innovation Owner: ${r.innovationOwner ? r.innovationOwner.name : ''} \r\n`
        }
        if (this.userReports && this.userReports.length == 0) {
          this.getPSCAdmins();
        } else {
          this.isLoading = false;            
        }
        this.isLoading = false;
      })
    }
  }

  getPSCAdmins() {
    if (this.user.isAdmin && this.viewingDashboardAsEmployee) {
      this.dealersService.getEmployeesForDealership(this.bac).subscribe((res: DealerEmployee[]) => {
        this.pscAdmins = res.filter(e => e.gmvssmadminroledn != 'USER');
        this.isLoading = false;
      })
    } else {
      this.dealersService.getEmployeesForDealership().subscribe((res : DealerEmployee[]) => {
        this.pscAdmins = res;
        this.isLoading = false;
      })
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.isMobile = window.innerWidth < 768;
  }

  openReport(report: Report) {
    if (report.reportType == 'cognos') {
      window.open(report.url);
      if (this.user.businessFunction == 'DEALER') this.viewService.addView(report.id, this.user.bac, ViewEntityType.report).subscribe(res => {});
    } else {
      if ((this.viewingDashboardAsPSC || this.viewingDashboardAsEmployee) && this.user.isAdmin) {
        this.router.navigate(['/reports/viewas/embed', report.reportGuidPbi, this.bac],
        { queryParams: { dealer: this.dealerName } });
      } else {
        this.router.navigate(['/reports/embed', report.reportGuidPbi]);
      }
    }
    this.clickstream.send('open-report', 'click', 'Reports', 'Report Button', '', true);
  }

  goToManageReports() {
    this.router.navigate(['/reports/manage'])
    this.clickstream.send('click-manage-reports', 'click', 'Reports', 'Manage Report Button', '', true);
  }

  openViewReportsOfDialog() {
    const isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent)
    if (isIEOrEdge) {
      this.dialog.open(ViewReportsAsDialogComponent, {
        width: '1200px',
        minHeight: '630px'
      });
    } else {
      this.dialog.open(ViewReportsAsDialogComponent)
    }
  }

  openAdminsDialog() {
    const dialogRef = this.dialog.open(AdminsDialogComponent);

    
  }
}